import { render } from "./BasicFloatButton.vue?vue&type=template&id=1a0db0c8"
import script from "./BasicFloatButton.vue?vue&type=script&lang=js"
export * from "./BasicFloatButton.vue?vue&type=script&lang=js"
script.render = render

export default script